import styled from 'styled-components/macro';
import { FlexAlignRight } from '../../../../shared-styles/flex';

export const CommentsTextField = styled.textarea`
  width: 100%;
  font-family: ${({ theme }) => theme.typography.fonts.default};
  border: 1px solid ${(props) => (props.error ? props.theme.palette.palette.red[100] : props.theme.palette.gray[100])};
  border-radius: 10px;
  padding: ${(props) => props.theme.spacing(10)};
  margin-top: ${(props) => props.theme.spacing(8)};

`;

export const CommentsCount = styled.span`
  ${FlexAlignRight};
  font-size: ${(props) => props.theme.typography.sizes.base};
  color: ${(props) => (props.invalid ? props.theme.palette.red[100] : props.theme.palette.gray[100])};
`;
